import React, { useState, useContext } from "react";
import { Grid, Typography, TextField } from "@material-ui/core";
import { PrimaryButton } from "../../Shared/Buttons";
import ConfirmationModal from "../../Shared/ConfimationModal";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { CustomerAction } from "../../Store/Reducers/Customer-reducer";

const CustomerDetails = ({ customerData, classes, setCustomerData }) => {
  const { customerData: customerDataList } = useSelector(
    (state) => state.Customer
  );
  const { id } = useParams();
  const dispatch = useDispatch();
  let editedCustomer;
  let newCustomersList = [...customerDataList];
  const manageRedux = () => {
    customerDataList.map((item, index) => {
      if (item.customer_id === id) {
        editedCustomer = {
          ...newCustomersList[index],
          enabled: !newCustomersList[index].enabled,
        };
        newCustomersList[index] = editedCustomer;
      }
    });
    dispatch(CustomerAction.setCustomerList(newCustomersList));
  };
  const [blocked, setBlocked] = useState(customerData.user_enabled);
  const [isOpen, setisOpen] = useState({
    open: false,
    content: "",
  });

  const deleteUser = async () => {
    const url = blocked
      ? `${process.env.REACT_APP_API_URL}customer/block`
      : `${process.env.REACT_APP_API_URL}customer/unblock`;
    try {
      const res = await axios.post(url, {
        phone_number: customerData.contactNumber,
      });

      const tempObj = customerData;
      tempObj.user_enabled = !customerData.user_enabled;
      setCustomerData(tempObj);

      setBlocked(!blocked);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        throw new Error(error.response.data.error);
      }
      if (error.message) {
        throw new Error(error.message);
      }
    }
  };
  return (
    <Grid justify="center" container direction="column">
      <Grid item xs={8}>
        <Typography variant="body1" color="primary">
          Name
        </Typography>
      </Grid>
      <Grid item xs={8} className={classes.mt10}>
        <TextField
          variant="outlined"
          fullWidth
          color="primary"
          size="small"
          className={classes.textFieldStyles}
          name="name"
          value={customerData.name}
          disabled={true}
        />
      </Grid>

      <Grid item xs={8} className={classes.mt20}>
        <Typography variant="body1" color="primary">
          E-mail
        </Typography>
      </Grid>
      <Grid item xs={8} className={classes.mt10}>
        <TextField
          variant="outlined"
          fullWidth
          color="primary"
          size="small"
          className={classes.textFieldStyles}
          name="email"
          value={customerData.email}
          disabled={true}
        />
      </Grid>
      <Grid item xs={8} className={classes.mt20}>
        <Typography variant="body1" color="primary">
          Number
        </Typography>
      </Grid>
      <Grid item xs={8} className={classes.mt10}>
        <TextField
          variant="outlined"
          fullWidth
          color="primary"
          size="small"
          className={classes.textFieldStyles}
          name="contactNumber"
          value={customerData.contactNumber}
          disabled={true}
        />
      </Grid>

      <Grid item xs={8} className={classes.mt50}>
        <PrimaryButton
          type={blocked ? "danger" : "success"}
          size="large"
          testId={blocked ? "block_btn" : "unblock_btn"}
          handleClick={() => {
            let content = blocked
              ? "Are you sure you want to block this user ?"
              : "Are you sure you want to unblock this user ?";
            setisOpen({
              open: true,
              content: content,
            });
            manageRedux();
          }}
        >
          {blocked ? "Block User" : "Unblock user"}
        </PrimaryButton>
        {isOpen.open && (
          <ConfirmationModal
            open={isOpen.open}
            content={isOpen.content}
            // item={isOpen.item}
            deleteHandler={deleteUser}
            setIsopen={setisOpen}
            buttonName={blocked ? "Block" : "Unblock"}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default CustomerDetails;
